import { useSubscription } from '@/hooks/useSubscription';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

export const SubscriptionLock = () => {
  const { currentTier } = useSubscription();
  const navigate = useNavigate();

  if (currentTier !== 'none') {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-background/95 backdrop-blur-sm flex items-center justify-center z-[9999] p-6">
      <div className="max-w-md text-center space-y-4">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Lock className="w-8 h-8 text-primary" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-foreground">Members Area – Locked</h2>
        <p className="text-sm text-muted-foreground">
          This tab is reserved for active Neil AI customers. Choose your plan to unlock your AI agents, funnels and automation studio instantly.
        </p>
        <Button
          onClick={() => navigate('/ai-automation')}
          className="w-full"
          size="lg"
        >
          View Plans & Activate Access
        </Button>
        <p className="text-xs text-muted-foreground">
          Already paid on this device? Refresh this page or return via your checkout success link.
        </p>
      </div>
    </div>
  );
};
